import OpenQuoteIcon from '@assets/vectors/openquote_small.inline.svg';

import QuickLink from '.';

const Community: QuickLink = ({ header, description }) => {
	return {
		Icon: OpenQuoteIcon,
		header,
		description,
		pathName: '/app/innerspace',
	};
};

export default Community;
